import { handleNetworkError } from "@/utility/networkError.utility";
import { useGetAuthUserService } from "@repo/api-services/admin";
import { handleGlobalPatchRequest } from "@repo/api-services/changeRequestsGlobal.ts";
import URLS from "@repo/api-services/URLS";
import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import toast from "react-hot-toast";
import useRoutesHandler from "./useRouteHandler";

export default function useAuthentication() {
  const { navigate } = useRoutesHandler();
  const { authService } = useGetAuthUserService();

  const authUpdateMutation = useMutation({
    mutationFn: (data: any) => {
      return handleGlobalPatchRequest({
        url: `${URLS.AUTH_USER}/${data.id}`,
        data,
      });
    },
    onSuccess: () => {
      toast("SuccessFully Update Profile");
      authService.refetch();
    },
    onError: (error: any) => {
      handleNetworkError(error.response);
    },
  });

  useEffect(() => {
    if (authService.isLoading || authService.status === "pending")
      return () => {};
    if (authService.status === "error") {
      navigate("/login");
      return () => {};
    }
  }, [authService.isLoading, authService.status]);

  // VARIABLE/s
  const authData = authService?.data || {};

  return {
    authData,
    services: { authService },
    mutations: { authUpdateMutation },
  };
}
